import * as React from "react"
import { Dispatch, SetStateAction } from "react"
import { set } from "react-hook-form"

interface CollaborationSoftwareProps {
  softwareSelectedOption: { title: string } | undefined
  setSoftwareSelectedOption: Dispatch<
    SetStateAction<{ title: string } | undefined>
  >
}
export const CollaborationSoftware = ({
  setSoftwareSelectedOption,
  softwareSelectedOption,
}: CollaborationSoftwareProps) => {
  const data = [
    {
      title: "Choose Software for Collaboration",
      options: [
        {
          title: "Slack",
        },
        {
          title: "Asana",
        },
        {
          title: "Jira",
        },
        {
          title: "Trello",
        },
        {
          title: "Whatsapp",
        },
        {
          title: "Discord",
        },
      ],
    },
  ]
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
          {data[0].title}
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <div className="flex mx-2 justify-center">
        <form className="flex justify-center flex-wrap lg:gap-10 gap-3 items-center mt-10">
          {data[0].options.map((option, index) => (
            <div
              onClick={() =>
                setSoftwareSelectedOption(
                  softwareSelectedOption?.title === option?.title
                    ? undefined
                    : option
                )
              }
              key={index}
              className="flex gap-2 items-center"
            >
              <div className="border border-[#7B68EC] rounded-full flex items-center p-1">
                <input
                  className="input-radio"
                  type="radio"
                  id={option.title}
                  value={option.title}
                  name="collaboration"
                  checked={option.title === softwareSelectedOption?.title}
                  readOnly
                />
              </div>
              <label className="text-black" htmlFor={option.title}>
                {option.title}
              </label>
            </div>
          ))}
        </form>
      </div>
    </div>
  )
}
